
import fetchApi from "../fetch-api";
import { getQueryPath } from "ui-io/get-query-path";
import { DealByIndustriesIO } from "../deal-io";

type CompanyByIdPropsT = {
  date?: string;
  limit?: number;
};

export const getTopIndustry = (props: CompanyByIdPropsT) => {
  let params = props;
  const queryPath = getQueryPath({...params});
  return {
    queryKey: ["TOP_INDUSTRY", queryPath],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        headers:{method: 'GET'},
        pathname: `/top-funded-industry?${ queryPath}`,
        codec: DealByIndustriesIO,
      }),
  };
};
